import { cartAnimation } from '@/lib/cart-animation';
import { useCart } from '@/store/quick-cart/cart.context';
import { generateCartItem } from '@/store/quick-cart/generate-cart-item';
import { ISearchProduct } from '@/types';
import { useProductPromotionalPack } from './useProductPromotionalPack';
import { toast } from 'react-toastify';
import {
  getOrderLimitFromCharacteristics,
  promotionalPackHasPayRule,
} from '@/lib/utils/product';

const getQuantityToAddOrRemove = ({
  current_product_quantity,
  promotional_pack_details,
}: any) => {
  if (
    current_product_quantity <
    promotional_pack_details.promotional_pack_quantity
  )
    return (
      promotional_pack_details.promotional_pack_quantity -
      current_product_quantity
    );

  if (
    current_product_quantity >
      promotional_pack_details.promotional_pack_quantity &&
    current_product_quantity %
      promotional_pack_details.promotional_pack_quantity !==
      0
  ) {
    return (
      current_product_quantity -
      promotional_pack_details.promotional_pack_quantity
    );
  }

  return promotional_pack_details.promotional_pack_quantity;
};

export const AddPromotionalPackToCartButton = ({
  product,
}: {
  product: ISearchProduct;
}) => {
  const { isInCart, addItemToCart, removeItemFromCart, countItemsInCartById } =
    useCart();

  const {
    disabledState,
    promotional_pack_details,
    promotional_pack_formatted_price,
  } = useProductPromotionalPack(product);

  const payValue = promotionalPackHasPayRule(product?.characteristics);

  return (
    <>
      {promotional_pack_details.is_promotional_pack && (
        <button type="button"
          className={`overflow-hidden text-[11px] font-bold rounded-full focus:outline-none ${payValue ? 'bg-amber-100' : 'bg-[#e1ebf4]'} text-blue-800 transition duration-300 ease-in-out whitespace-nowrap`}
          disabled={disabledState}
          onClick={
            (e) => {
              const packQuantity =
                promotional_pack_details.promotional_pack_quantity;
              if (!packQuantity) return;

              const productItem = generateCartItem(product);
              if (!isInCart(productItem.id)) {
                cartAnimation(e);
              }

              const current_product_quantity = countItemsInCartById(
                productItem.id,
              );

              const quantityCalc = getQuantityToAddOrRemove({
                current_product_quantity,
                promotional_pack_details,
              });

              // Check order limit validation
              const orderLimit = getOrderLimitFromCharacteristics(product.characteristics || []);
              if (
                orderLimit &&
                orderLimit > 0 &&
                current_product_quantity + quantityCalc > orderLimit
              ) {
                toast.error(
                  `Limite por pedido excedido. Máximo permitido para este produto: ${orderLimit}`,
                );
                return;
              }

              const shouldResetToDefaultPromotionalPackValue =
                current_product_quantity > packQuantity &&
                current_product_quantity % packQuantity !== 0;

              if (
                current_product_quantity &&
                current_product_quantity === packQuantity
              )
                return;

              if (shouldResetToDefaultPromotionalPackValue)
                return removeItemFromCart(productItem.id, quantityCalc);

              addItemToCart(productItem, quantityCalc);
            }
            // TODO:  Review if is needed
            // handleProductQuickView({ selectedTab: 'leve-mais-por-menos' })
          }
        >
          <div className="grid grid-cols-[min-content,1fr]">
            <span
              className={`mr-2 py-1 px-2 ${payValue ? 'bg-amber-300' : 'bg-[#197fdb] text-white'} flex items-center justify-center`}
            >
              {promotional_pack_formatted_price}
            </span>
            <span className="mr-2 py-1 px-2 flex items-center justify-center">
              {promotional_pack_details.promotional_pack_label}
            </span>
          </div>
        </button>
      )}
    </>
  );
};
